module.exports = __webpack_public_path__ + "static/img/aid.c1b7cd96.png";